import { RotatingLines } from 'react-loader-spinner'
import styles from './style.module.css'
import { useSelector } from 'react-redux'
const RotatingLinesLoader = () => {
    const { theme } = useSelector((state) => state?.sideBar)
    return (
        <div className={`${styles.loaderContainer}`}>
            <RotatingLines
                strokeColor={
                    theme === 'dark'
                        ? 'white'
                        : theme === 'light'
                        ? '#172B4D'
                        : '#aab8c5' // Add the color for the third theme here
                }
                strokeWidth="5"
                animationDuration="0.75"
                width="96"
                visible={true}
            />
        </div>
    )
}
export default RotatingLinesLoader
